import { Decimal } from 'decimal.js'

import { store } from 'store'
import { getPointsMultiplier } from 'models/General/selectors'

import { STRING, SYMBOLS } from 'resources'

import getDecimalValue from './get-decimal-value'

const formatter = new Intl.NumberFormat('en-US')

/**
 * Formats the amount as points based on the `amount`
 * @param {number|string|Decimal} amount The dollar amount to be formatted
 */
export const convertAmountToPoints = (amount) => {
  const state = store.getState()
  const pointsMultiplier = getPointsMultiplier(state)
  const decimalValue = getDecimalValue(amount)
  return decimalValue.toDecimalPlaces(2, Decimal.ROUND_UP).mul(pointsMultiplier)
}

/**
 * Formats the points into amount based on the `points`
 * @param {number|string|Decimal} points The points amount to be formatted
 */

export const convertPointsToAmount = (points) => {
  const state = store.getState()
  const pointsMultiplier = getPointsMultiplier(state)
  const decimalValue = getDecimalValue(points)
  return decimalValue.toDecimalPlaces(2, Decimal.ROUND_UP).div(pointsMultiplier)
}

/**
 * Formats the amount as points based on the `pointsMultiplier`
 * @param {number|string|Decimal} amount The dollar amount to be formatted
 * @param {boolean} [withLongUnits=false] Whether the "POINT"/"POINTS" suffix is added
 * @param {boolean} [withShortUnits=false] Whether the "PT"/"PTS" suffix is added
 * @param {boolean} [withPlusSign=false] Whether the formatted value has "+" prefix
 */

const formatPoints = (amount, withLongUnits = false, withShortUnits = false, withPlusSign = false) => {
  const pointsValue = convertAmountToPoints(amount)
  const formattedValue = formatter.format(pointsValue)

  let prefix = ''
  if (withPlusSign && pointsValue.gt(0)) {
    prefix = SYMBOLS.plus
  }

  let suffix = ''
  if (withLongUnits) {
    const unit = pointsValue.abs().equals(1) ? STRING.units.point : STRING.units.points
    suffix = ` ${unit}`
  } else if (withShortUnits) {
    const unit = pointsValue.abs().equals(1) ? STRING.units.pointShort : STRING.units.pointsShort
    suffix = ` ${unit}`
  }

  return `${prefix}${formattedValue}${suffix}`
}

export default formatPoints
